// extracted by mini-css-extract-plugin
export default {"body":"aZq3EEhOpWbCbrxwyw2L","mobile":"SJmmtkkoBQTLIDYAkBaY","contentInner":"_PpBPOo5MtatD035p3hJ","closeButton":"hYVmPknl3KB3HnYVuIka","main":"TPDDsh8cr8Zmvzfxaw0T"};